import { loadFirebaseAuth } from "./firebase";
import { signInWithPopup, FacebookAuthProvider } from "firebase/auth";
import { catch_error, get_user_info } from "./functions";

$("#facebook_signin, #facebook_register").on("click", function () {
  const provider = new FacebookAuthProvider();
  const auth = loadFirebaseAuth();
  auth.useDeviceLanguage();

  signInWithPopup(auth, provider)
    .then((res) => {
      localStorage.setItem("user", JSON.stringify(res.user));
      localStorage.setItem(
        "login_result",
        JSON.stringify({
          is_logged_in: true,
          access_token: res.user.accessToken,
          expiry_date: Date.now() + 50 * 60000,
        })
      );
    })
    .then(() => {
      $("#popup-login").remove();
      $("#popup-register").remove();

      if ($("#not-logged-in-profile")) {
        $("#not-logged-in-profile").css("display", "none");
      }

      var element =
        $(`<li class="loading-profile" id="loading-profile"><a href = "/profile" >
    /wp-content/themes/atyabtabkha/src/assets/images/svg/ico-spinner-alt.svg
      </a></li>`);

      $("#header-profile-props").append(element);

      setTimeout(() => {
        get_user_info(true, false, false);
      }, 3000);
    })
    .catch((error) => {
      catch_error(error);
      const credential = FacebookAuthProvider.credentialFromError(error);
      console.error(credential);
    });
});
